export enum HomePageType {
  GATED = "gated_homepage",
}
